// src/hooks/useAuthForm.js
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const useAuthForm = ({
  initialValues,
  validateFn,
  submitFn,
  onSuccessNavigateTo,
  initialStep = null,
  formName = '',
  onNoSubscriptionNavigateTo
}) => {
  const [form, setForm] = useState(initialValues);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [step, setStep] = useState(initialStep);
  const navigate = useNavigate();

  const validate = () => {
    const errs = step !== null ? validateFn(form, step) : validateFn(form);
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const onChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: undefined });
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    setLoading(true);
    try {
      let response;
      if (formName === "ContactUsForm") {
        response = await submitFn({ contact_message: form });
      } else {
        response = await submitFn({ user: form });
      }

      if (!response || !response.success) {
        throw new Error(response?.error || 'Submission failed');
      }

      const { data, message } = response;
      const { token, email_verify, phone_verify, email } = data || {};
      const emailVerified = localStorage.getItem('email_verify');
      // 2️⃣ Only email
      if (emailVerified === "false" || emailVerified === false) {
        navigate('/verify-email', {
          state: {
            email,
            message: "Please verify your email to continue",
            label: "Verify Email",
          },
        });
        return;
      }

      const destination = onSuccessNavigateTo || '/';
      // const navigationUrl = !data?.package ? onNoSubscriptionNavigateTo :  destination;
      navigate(destination, {
        state: {
          email,
          successMessage: message,
          redirectUrl: '/forgot-password-otp', // if needed
          label: 'Next Step',
        },
      });
    } catch (err) {
      console.error(`Error in ${formName} onSubmit:`, err);
    } finally {
      setLoading(false);
    }
  };

  const onTestingSubmit = async (e) => {
    e.preventDefault();

    let errs = {};

    if (!form.email) {
      errs.email = 'Email is required';
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(form.email)
    ) {
      errs.email = 'Invalid email address';
    }

    setErrors(errs);

    if (Object.keys(errs).length > 0) return;

    setLoading(true);

    try {
      const payload = {
        email: form.email,
        phone: '9876543210',
        sector: 'Books',
        password: 'Test@123',
        password_confirmation: 'Test@123',
      };

      const response = await submitFn({ user: payload });

      if (!response || !response.success) {
        throw new Error(response?.error || 'Submission failed');
      }

      const { data, message } = response;
      const { token, email_verify, phone_verify, email } = data || {};
      const emailVerified = localStorage.getItem('email_verify');
      if (emailVerified === "false" || emailVerified === false) {
        navigate('/verify-email', {
          state: {
            email,
            message: "Please verify your email to continue",
            label: "Verify Email",
          },
        });
        return;
      }
    } catch (err) {
      console.error('Testing signup error:', err);
    } finally {
      setLoading(false);
    }
  };

  return {
    form,
    onChange,
    onSubmit,
    loading,
    validate,
    result,
    errors,
    step,
    setStep,
    onTestingSubmit
  };
};

export default useAuthForm;
